import Australia from './Australia';
import Brazil from './Brazil';
import Canada from './Canada';
import EuropeanUnion from './EuropeanUnion';
import GreatBritain from './GreatBritain';
import India from './India';
import Japan from './Japan';
import NewZealand from './NewZealand';
import UnitedStates from './UnitedStates';

export const flags = {
  Australia,
  Brazil,
  Canada,
  EuropeanUnion,
  GreatBritain,
  India,
  Japan,
  NewZealand,
  UnitedStates,
};
